export const T = {
  en_GB: {
    noOrders: "No orders yet. Orders are created automatically when a flow is completed.",
    product: "Product",
    target: "Target",
    executed: "Executed",
    status: "Status",
    order: "order",
    orders: "orders",
    noOrdersFilter: "No orders match the selected filter.",
    type: "Type",
    viewDetails: "View order details",
    deviatesFromTarget: "Differs from target",
    estimatedShort: "est.",
    switchFrom: (product: string) => `from ${product}`,
    proceedsFromSale: "Proceeds from the sale",
    estimatedProceeds: (percent: string) =>
      `Estimated proceeds of selling ${percent}% of the position`,
    switchUnitsToSell: (product: string) => `Units of ${product} to sell`,
    switchUnitsSold: (product: string) => `Units of ${product} sold`,
    estimatedProceedsAmount: (amount: string) => `estimated proceeds ${amount}`,
    proceedsAmount: (amount: string) => `proceeds ${amount}`,
    switchInProgress: "Bank is completing the switch — the buy side may take several days.",
  },
  nb_NO: {
    noOrders: "Ingen ordrer ennå. Ordrer opprettes automatisk når en flyt fullføres.",
    product: "Produkt",
    target: "Mål",
    executed: "Utført",
    status: "Status",
    order: "ordre",
    orders: "ordrer",
    noOrdersFilter: "Ingen ordrer samsvarer med det valgte filteret.",
    type: "Type",
    viewDetails: "Vis ordredetaljer",
    deviatesFromTarget: "Avviker fra målet",
    estimatedShort: "ca.",
    switchFrom: (product: string) => `fra ${product}`,
    proceedsFromSale: "Proveny fra salget",
    estimatedProceeds: (percent: string) =>
      `Estimert proveny ved salg av ${percent}% av posisjonen`,
    switchUnitsToSell: (product: string) => `Andeler av ${product} som skal selges`,
    switchUnitsSold: (product: string) => `Solgte andeler av ${product}`,
    estimatedProceedsAmount: (amount: string) => `estimert proveny ${amount}`,
    proceedsAmount: (amount: string) => `proveny ${amount}`,
    switchInProgress: "Banken fullfører byttet — kjøpssiden kan ta flere dager.",
  },
} as const;
